module.exports = __webpack_public_path__ + "img/mittige_einzellast.0c90e91d.png";